module.exports = __webpack_public_path__ + "img/semipublic.62a6b2ce.svg";